var path = 'app/scripts/modules/google/src/cache/cacheRefreshTooltip.html';
var html = "<p ng-if=\"$ctrl.refreshing\">{{$ctrl.capitalizedKey}} data is <strong>refreshing</strong></p>\n<p ng-if=\"!$ctrl.refreshing\">(click <span class=\"fa fa-refresh\"></span> to refresh)</p>\n<p>Last refresh: {{$ctrl.getRefreshTime() | timestamp }}</p>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/google/src/cache/cacheRefreshTooltip.html
// module id = 1292
// module chunks = 0